export default "__VITE_ASSET__D2EQnAC2__"